import BonusActivePanelUntilContent from "./BonusActivePanelUntilContent.jsx";
import BonusActiveItem from "./BonusActiveItem.jsx";
import {memo} from "react";
import {BonusInfoIconTooltipStyled} from "../../../../components/InfoIcon/styled/InfoIconStyled.js";
import {BinIcon} from "../../../../components/icon/Icon.jsx";
import {LINKS} from "../../../../app/appConstants.js";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext.js";

const BonusGift50Terms = memo(({bonus, style}) => {
    const {getLangPath} = useLangContext();
    const bonusAmount = bonus?.credit || 0;
    const negativeBalanceLimit = bonusAmount - 0.01;
    return <BonusInfoIconTooltipStyled style={style}>
                <ol dangerouslySetInnerHTML={{__html: getLangPath('bonus.gift50.terms', {
                        bonus_amount: bonusAmount,
                        negative_balance_limit: negativeBalanceLimit,
                    })}}/>
                <div className="d-flex align-items-center">
                    <BinIcon name="IcSquareArrowUpRight"/>
                    <a className="ms-1" href={LINKS.promotionsDoc} target="__blank">
                        {getLangPath('bonus.gift50.information_link')}
                    </a>
                </div>
            </BonusInfoIconTooltipStyled>
});

function BonusGift50(props) {
    const {bonus, flat} = props;
    return <BonusActiveItem bonus={bonus} flat={flat} infoComponent={<BonusGift50Terms bonus={bonus}/>}>
        <BonusActivePanelUntilContent bonus={bonus} flat={flat}/>
    </BonusActiveItem>;
}

export default BonusGift50;
